import React from "react";
import ModuleNavigation from "../ModuleNavigation";

export default function SoftwareModule() {
  return <ModuleNavigation moduleId="SoftwareModule" />;
}
